import React from "react";
import "../../assets/styles/components/_login.scss";
import logo from "../../assets/images/brand/Tensolite-Isologotipo-blanco.png";
import useForm from "../../hooks/useForm";
import useLogin from "../../hooks/useLogin";
import toast from "react-hot-toast";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { ROLES_CLIENTES } from "../../helpers/constants";
import { useState } from "react";
import { useLocation } from "react-router";

const LoginClienteCard = () => {
  const {
    values,
    handleInputChange,
    emailError,
    passwordError,
    errorEmailInput,
    errorPasswordInput,
  } = useForm({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const { handleSubmit } = useLogin();

  const MostrarMensajeError = (event) => {
    toast.error("Email y/o contraseña incorrectos");
    event.preventDefault();
  };

  const VerificarCampos = (event, values) => {
    !emailError && !passwordError
      ? handleSubmit(event, values, queryParams.toString().length > 0 ? `/calculadora-losa-con-viguetas?${queryParams.toString()}` : "/calculadora-losa-con-viguetas", ROLES_CLIENTES)
      : MostrarMensajeError(event);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="text-login">
        <div className="text-login__title">
            <h3>Inicia sesión o REGÍSTRATE GRATIS para visualizar los resultados de tu cálculo.</h3>
        </div>
      </div>
      <form
        className="container login__card-form"
        onSubmit={(event) => VerificarCampos(event, values)}
        >
        <div className="logo-login">
          <img src={logo} alt="Logo Tensolite" className="logo" />
        </div>
        <div className="flex-row">
          <input
            type="text"
            id="email"
            name="email"
            className={`lf--input ${errorEmailInput ? "input-error" : ""} `}
            placeholder="Email"
            value={values.email}
            onChange={handleInputChange}
          />
        </div>

        <div className="flex-row login__card-form__second_password gap-x-2 items-center ">
          <input
            maxLength={12}
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            className={`lf--input new-second-input-password ${
              errorPasswordInput ? "input-error" : ""
            } `}
            placeholder="Contraseña"
            value={values.password}
            onChange={handleInputChange}
          />
          <button
            type="button"
            className="second-password-toggle-button"
            onClick={toggleShowPassword}
          >
            {showPassword ? (
              <VisibilityOffIcon
                sx={{
                  color: "white",
                }}
              />
            ) : (
              <VisibilityIcon
                sx={{
                  color: "white",
                }}
              />
            )}
          </button>
        </div>
        <input type="submit" className="button--submit" value="INGRESAR" />
        <label className="super-label-recover">
          <a href="/clientes/olvide-password">¿Olvidaste tu contraseña?</a>
        </label>
         <label className="super-label-recover-register">
          <a href={queryParams.toString().length > 0 ? `/clientes/registro?${queryParams.toString()}` : "/clientes/registro"} className="button-register">REGISTRATE</a>
        </label>
      </form>
    </>
  );
};

export default LoginClienteCard;
